import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import PageWrap from '../components/PageWrap';
import useDocumentMeta from '../hooks/useDocumentMeta';
import routeMetaFor from '../utils/routeMeta';
import { ABOUT_PAGE, HOME, STUDIO } from '../data/siteContent';

export default function About() {
  useDocumentMeta(routeMetaFor('/about'));
  return (
    <PageWrap testId="about-page">
      <Navbar />
      <section className="page-hero">
        <div className="blob blob-1"></div>
        <div className="blob blob-2"></div>
        <div className="wrap" style={{ position: 'relative', zIndex: 1 }}>
          <div className="eyebrow reveal">{ABOUT_PAGE.eyebrow}</div>
          <h1 className="reveal d1">{ABOUT_PAGE.title}</h1>
          <p className="lead reveal d2">{STUDIO.aboutOpening}</p>
        </div>
      </section>

      <section className="section">
        <div className="wrap">
          <h2 className="reveal" style={{ marginBottom: '16px', fontSize: '1.4rem' }}>{ABOUT_PAGE.approachHeading}</h2>
          <p className="reveal" style={{ marginBottom: '14px', maxWidth: '760px' }}>{STUDIO.primaryStatement}</p>
          <p className="reveal" style={{ marginBottom: '32px', maxWidth: '760px' }}>{STUDIO.supportingStatement}</p>
          <Link to={HOME.primaryCta.to} className="btn btn-primary btn-lg reveal" data-testid="about-products-cta">
            {HOME.primaryCta.label}
          </Link>
        </div>
      </section>
      <Footer />
    </PageWrap>
  );
}
